import { withChartLayout } from 'components/common';
import PlanningHospitalStay from 'components/features/chart/admission-history/planning-hospital-stay/PlanningHospitalStay';

const PlanningHospitalStayPage = withChartLayout('Planning for Hospital Stay')(PlanningHospitalStay);
export default PlanningHospitalStayPage;
